import Vuex from 'vuex';
import Vue from 'vue';
import errors from './modules/errors';
import auth from './modules/auth';
import jobs from './modules/jobs'
import licenses from './modules/licenses';
import servers from './modules/servers';
import siteini from './modules/siteini';
import channels from './modules/channels';
import settings from './modules/settings';
import grab from './modules/grab';
import programme from './modules/programme';
import vodguide from "./modules/vodguide";
import logbook from './modules/logbook';
import vodsets from "./modules/vodsets";


Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    errors,
    auth,
    jobs,
    licenses,
    servers,
    siteini,
    channels,
    settings,
    grab,
    programme,
    logbook,
    vodsets,
    vodguide
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js